import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { DateTime } from 'luxon';
import { Constant } from 'src/app/constant/constant';
import { EcryptServiceService } from 'src/app/services/ecrypt-service.service';
import { environment } from 'src/environments/environment';
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { Router, NavigationEnd } from "@angular/router";

import { animate, state, style, transition, trigger } from '@angular/animations';

import { LeadActivityService } from 'src/app/services/lead-activity.service';
import { MatDialog } from '@angular/material/dialog';
import { TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'calsoft-child-activitiy',
  templateUrl: './child-activitiy.component.html',
  styleUrls: ['./child-activitiy.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state('open', style({ height: '*', opacity: 1, padding: '8px 0' })),
      state('closed', style({ height: '0px', opacity: 0, padding: '0' })),
      transition('open <=> closed', animate('200ms ease-in-out')),
    ]),
  ]
})
export class ChildActivitiyComponent implements OnInit {

  @ViewChild('contentDialog') contentDialog!: TemplateRef<any>;

  url = '';
  sanitizedUrl = '';
  generatingAiMap: { [key: number]: boolean } = {};
  selectedActivity: any = null;

  public serverPath = environment.commonImageApi + '/courseAudio/';

  cid: any;

  @Input() date: any;



  @Input() acto: any;

  @Input() beforeDate: any;



  @Input() afterDate: any;

  @Input() activity: any;

  @Input() first: any;

  @Input() last: any;

  formatedDate: string;
  isSameDayDate: boolean = false;
  dateShow: any;
  nextDate: boolean;
  iconName: any;

  constructor(private datepipe: DatePipe,
    private ecryptService: EcryptServiceService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private leadActivityService: LeadActivityService,
    private dialog: MatDialog
  ) {
    this.url = this.router.url || '';
    // this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      // this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

  }

  generateAiAnalysis(activity: any): void {
    if (!activity || !activity.id) return;
    this.generatingAiMap[activity.id] = true;
    this.leadActivityService.generateAiForActivity(activity.id).subscribe(
      (res: any) => {
        this.generatingAiMap[activity.id] = false;
        const updated = res.data || res;
        if (updated) {
          activity.transcript = updated.transcript;
          activity.callSummary = updated.callSummary;
          activity.report = updated.report;
        }
        this.cdr.detectChanges();
      },
      (err: any) => {
        this.generatingAiMap[activity.id] = false;
        this.cdr.detectChanges();
      }
    );
  }

  viewReport(activity: any): void {
    this.selectedActivity = activity;
    this.dialog.open(this.contentDialog, { width: '700px' });
  }

  closeModal(): void {
    this.dialog.closeAll();
  }


  taskType: any = 0;

  ngOnInit(): void {


    this.getAllCrmData();

    let values = localStorage.getItem(Constant.enterPriseKey);

    this.cid = "&cid=" + values

    if (this.activity.activityType == "Follow Up") {
      this.iconName = "list_alt";
    }
    else if (this.activity.activityType == "Phone Call") {
      this.iconName = "phone";
    }
    else if (this.activity.activityType == "statusChange") {
      this.iconName = "local_activity";

    } else if (this.activity.activityType == "ownerChange") {
      this.iconName = "person";

    } else if (this.activity.activityType == "NewLead") {
      this.iconName = "list_alt";
    } else if (this.activity.activityType == "OutboundCall") {
      this.iconName = "phone";
    } else if (this.activity.activityType == "duplicateLead") {
      this.iconName = "file_copy";
    }
    else if (this.activity.activityType == "emailSend") {
      this.iconName = "email";
    }
    else if (this.activity.activityType == "meeting") {
      this.iconName = "groups";
    }
    else if (this.activity.activityType == "Location") {
      this.iconName = "gps_fixed";
    }

    else if (this.activity.activityType == "") {
      this.iconName = "local_activity";
    }
    else if (this.activity.activityType == "Incoming") {
      this.iconName = "phone";
    }
    else if (this.activity.activityType == "Outgoing") {
      this.iconName = "phone";
    }
    else if (this.activity.activityType == "emailRecieved") {
      this.iconName = "email";
    }
    else if (this.activity.activityType == "Connected") {
      this.iconName = "phone";
    }
    else if (this.activity.activityType == "whatsappTemplateSend") {
      this.iconName = "chat_bubble";
    }
    else if (this.activity.activityType == "quotationCreation") {
      this.iconName = "receipt";
    }

    else if (this.activity.activityType == "invoiceCreation") {
      this.iconName = "receipt";
    }

    else if (this.activity.activityType == "emailReply") {
      this.iconName = "email";
    }

    else if (this.activity.activityType == "emailClicked") {
      this.iconName = "email";
    }

    else if (this.activity.activityType == "NewDeal") {
      this.iconName = "list_alt";
    }

    else if (this.activity.activityType == "messageSend") {
      this.iconName = "textsms";
    }


    this.dateShow = this.dateformatshow(this.activity.createdDate)

    this.isSameDayDate = this.isSameDay()


    this.formatedDate = this.getRelativeFormattwo(this.date)




  }


  getAllCrmData() {

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {

          if (data['taskType'] != undefined) {
            this.taskType = data['taskType'];
          } else {
            this.taskType = 0;
          }

        } else {


          this.taskType = 0;


        }

      } catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
  }



  getRelativeFormattwo(date: string): string {

    date = this.dateformatshowNew(date);

    const inputDate = DateTime.fromFormat(date, 'MMM d, yyyy, h:mm a');

    if (!inputDate.isValid) {
      console.error("Invalid date format:", date);
      return 'Invalid Date';
    }

    const currentDate = DateTime.now().startOf('day');
    const diffDays = Math.floor(inputDate.diff(currentDate, 'days').days);

    if (diffDays === 0) {
      return 'Today';
    } else if (diffDays === -1) {
      return 'Yesterday';
    } else if (diffDays < 32) {
      return Math.abs(diffDays) + ' Days Ago';
    } else {
      return inputDate.toFormat('MMMM d, yyyy');
    }
  }

  isSameDay() {
    // return this.datepipe.transform(current, 'MMM d, h:mm a');

    const currentDay = this.datepipe.transform(this.date, 'yyyy-MM-dd');
    const compareDay = this.datepipe.transform(this.beforeDate, 'yyyy-MM-dd');

    const afterDay = this.datepipe.transform(this.afterDate, 'yyyy-MM-dd');

    let isSameDay = currentDay === compareDay;

    if (compareDay == null) {
      isSameDay = currentDay === afterDay;
    }

    if (currentDay == afterDay) {

      this.nextDate = true;
    } else {
      this.nextDate = false;
    }



    return isSameDay;
  }

  dateformatshowNew(date: string): string {
    return this.datepipe.transform(date, 'MMM d, yyyy, h:mm a'); // ✅ Add 'yyyy'
  }


  dateformatshow(date: string) {

    return this.datepipe.transform(date, 'MMM d, h:mm a');
  }

  // isSameDayNew() {
  //   // return this.datepipe.transform(current, 'MMM d, h:mm a');

  //   const currentDay = this.datepipe.transform(current, 'yyyy-MM-dd');
  //   const compareDay = this.datepipe.transform(compare, 'yyyy-MM-dd');

  //   let isSameDay = currentDay === compareDay;

  //   console.log();

  //   return isSameDay;
  // }
  toggleEmailDetails(activity: any) {
    activity.showEmailDetails = !activity.showEmailDetails;
  }

  isEmailActivity(type: string): boolean {
    if (!type) return false;
    const t = type.toLowerCase();
    return t === 'emailsend' || t === 'emailrecieved' || t === 'emailreply' || t === 'emailclicked' || t === 'email' || t.includes('email');
  }

  protected _onDestroy = new Subject<void>();

  sanitizeUrl(u: string): string {
    return (u || '').replace(/^\/+/, '').replace(/[?#&=]/g, '-').replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/-+/g, '-').replace(/^[-]+|[-]+$/g, '').toLowerCase();
  }

  loadingUrls = new Set<string>();

  audioBlobUrls: { [url: string]: string } = {};

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
    try {
      Object.values(this.audioBlobUrls).forEach(url => {
        if (url && url.startsWith('blob:')) {
          URL.revokeObjectURL(url);
        }
      });
    } catch (e) { }
  }

  // getAudioUrl(schedule: string): string {
  //   if (!schedule) return '';
  //   let url = schedule;
  //   if (url.includes('flowzo.ai')) {

  //     const cid = localStorage.getItem(Constant.enterPriseKey);
  //     if (cid && !url.includes('cid=')) {
  //       url += (url.includes('?') ? '&' : '?') + 'cid=' + cid;
  //     }

  //     if (this.audioBlobUrls[schedule]) {
  //       return this.audioBlobUrls[schedule];
  //     }

  //     this.loadAudioAsBlob(schedule, url);
  //   } else {
  //     url = this.serverPath + schedule;
  //     const cid = localStorage.getItem(Constant.enterPriseKey);
  //     if (cid && !url.includes('cid=')) {
  //       url += (url.includes('?') ? '&' : '?') + 'cid=' + cid;
  //     }
  //   }


  //   return url;
  // }

  getAudioUrl(schedule: string): string {
    if (!schedule) return '';
    let url = schedule;
    if (url.startsWith('http://')) {
      url = url.replace('http://', 'https://');
    }
    if (url.includes('flowzo.ai')) {
      const cid = localStorage.getItem(Constant.enterPriseKey);
      if (cid && !url.includes('cid=')) {
        url += (url.includes('?') ? '&' : '?') + 'cid=' + cid;
      }
    }
    else {
      url = this.serverPath + schedule;
      const cid = localStorage.getItem(Constant.enterPriseKey);
      if (cid && !url.includes('cid=')) {
        url += (url.includes('?') ? '&' : '?') + 'cid=' + cid;
      }
    }
    return url;
  }

  loadAudioAsBlob(originalUrl: string, resolvedUrl: string): void {
    if (this.audioBlobUrls[originalUrl]) return;
    this.audioBlobUrls[originalUrl] = 'LOADING';

    fetch(resolvedUrl)
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.blob();
      })
      .then(blob => {
        const objectUrl = URL.createObjectURL(blob);
        this.audioBlobUrls[originalUrl] = objectUrl;
        this.cdr.detectChanges();
      })
      .catch(err => {
        console.error('Failed to load audio as blob:', err);
        this.audioBlobUrls[originalUrl] = resolvedUrl;
        this.cdr.detectChanges();
      });
  }

}
